import GameModel from "./GameModel";
import Config from "../../../../../../shared/src/ranj/app/config/Config";
import NGTScenarioPlayer from "../../ngt/scenario/NGTScenarioPlayer";
import NGTVariableManager from "../../ngt/base/NGTVariableManager";
import ScenarioLibrary from "../../ngt/scenario/ScenarioLibrary";
import { isNull } from "../../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import BaseSaveModel from "../../../../../../shared/src/ranj/equalture/savegame/BaseSaveModel";

export default class SaveModel extends BaseSaveModel {

    /**
     * 
     * @param {GameModel} gameModel 
     * @param {Config} config 
     * @param {ScenarioLibrary} scenarioLibrary 
     * @param {NGTScenarioPlayer} scenarioPlayer 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(gameModel, config, scenarioLibrary, scenarioPlayer, variableManager) {
        super(config);
        this._gameModel = gameModel;
        this._scenarioLibrary = scenarioLibrary;
        this._scenarioPlayer = scenarioPlayer;
        this._variableManager = variableManager;
    }

    _createMinigameSaveGame() {
        const scenario = this._scenarioLibrary.getCurrentScenario();
        const storyPlayer = this._scenarioPlayer.getStoryPlayer();

        if(!scenario || !storyPlayer){
            throw new Error("[SaveModel] Cannot issue a save game without a current scenario or story player.")
        }

        const saveGame = {
            completed: this._gameModel.isScenarioCompleted(scenario.id),
            elapsedTime: this._gameModel.elapsedTime,
            scenarioId: scenario.id,
            storyMemento: storyPlayer.save().serialize(),
            dialogMemento: this._gameModel.currentDialogPlayer?.dialogMemento,
        };

        return saveGame;
    }
}
